import useWindowSize from './useWindowSize';

const useIsMobile = (breakpoint = 768) => {
  const {width: windowWidth} = useWindowSize();
  return !!windowWidth && windowWidth <= breakpoint;
};

export default useIsMobile;